var _circle, _path, _path2, _circle2, _ellipse, _ellipse2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#F6C899"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5469 35.5168C39.0415 34.1297 37.2327 34.5757 36.3916 34.972C35.1253 39.2247 38.8704 39.5743 40.9012 39.2176C39.1904 37.818 40.1788 37.2506 39.5469 35.5168Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8775 35.5168C13.383 34.1297 15.1917 34.5757 16.0329 34.972C17.2992 39.2247 13.5541 39.5743 11.5232 39.2176C13.2341 37.818 12.2457 37.2506 12.8775 35.5168Z",
    fill: "#292929"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3324,
    cy: 25.2119,
    r: 14.708,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.7822,
    cy: 28.2544,
    rx: 1.01434,
    ry: 1.52152,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.897,
    cy: 28.2544,
    rx: 1.01434,
    ry: 1.52152,
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8683 31.8052H24.5574C24.5574 32.8195 25.3181 33.5803 26.8396 33.5803C28.2741 33.5803 28.7838 32.4814 28.8683 31.8052Z",
    fill: "#F09387"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7156 22.0189H11.9495C13.3686 15.379 19.2691 10.3999 26.3325 10.3999C33.396 10.3999 39.2965 15.379 40.7156 22.0189Z",
    fill: "#FC8368"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.497 20.6276H22.9286C23.3021 18.8807 24.8545 17.5708 26.7128 17.5708C28.5712 17.5708 30.1236 18.8807 30.497 20.6276Z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile1);
export default __webpack_public_path__ + "static/media/img_profile_1.ce35dc9b5ece156448a36f59ff883ce8.svg";
export { ForwardRef as ReactComponent };